module.exports = __webpack_public_path__ + "static/media/teenager.19d82ec7.png";